import InlineStatusComponent from '72cms-ui/components/helpers/InlineStatusComponent';
import DateTimeComponent from '72cms-ui/components/table-elements/DateTimeComponent';

export default {
    fields: {
        created_at: {
            label: 'Updated',
            component: {
                template: `<div>
                    <span class="d-block">{{ _.datetime(initialValue).format('DD MMM YYYY') }}</span>
                    <span class="d-block">{{ _.datetime(initialValue).format('HH:mm:ss') }}</span>
                    <span v-if="data.email_sent" class="d-block mt-3"><b>Email sent</b></span>
                </div>`,
                props: ['initialValue', 'data'],
            },
        },
        comment: {
            label: 'Comment',
            component: {
                template: `<div style="height: 100%;">
                    <span class="d-block"><b>{{ _.get(data, 'created_by.name', '') }}</b></span>
                    <span v-html="__(initialValue, ['nl2br'])"></span>
                </div>`,
                props: ['initialValue', 'data'],
            }
        },
        status: {
            component: {
                template: `<span :class="['badge', flavor]">{{ initialValue }}</span>`,
                props: ['initialValue'],
                computed: {
                    flavor() {
                        switch (this.initialValue) {
                            case 'delivered': return 'badge-primary';
                            case 'open': return 'badge-success';
                            case 'click': return 'badge-success';
                            case 'deferred': return 'badge-warning';
                            case 'bounce': return 'badge-danger';
                            case 'drop': return 'badge-danger';
                            default: return 'badge-default';
                        }
                    }
                }
            }
        },
    },
    // inlineFormComponent: InlineStatusComponent,
    // emptyMessage: 'No status updates have been logged for this enquiry.',
    sortable: [],
    filterable: [],
    customFilters: [],
    pagination: false,
    searchable: false,
    hierarchy: false,
    batchActions: [],
    actions: [],
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.message-message_statuses.js